import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './NCAuth.css';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [needsNewPassword, setNeedsNewPassword] = useState(false);
  const [pendingUser, setPendingUser] = useState(null);
  const { signIn, completeNewPassword } = useAuth();
  const navigate = useNavigate();

  const handleSignIn = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await signIn(email, password);
      navigate('/my-streams');
    } catch (err) {
      if (err.code === 'NewPasswordRequired') {
        setPendingUser(err.cognitoUser);
        setNeedsNewPassword(true);
      } else {
        setError(err.message || 'Failed to sign in');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleNewPassword = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) { setError('Passwords do not match'); return; }
    if (newPassword.length < 8) { setError('Password must be at least 8 characters'); return; }
    setError('');
    setLoading(true);
    try {
      await completeNewPassword(pendingUser, newPassword);
      navigate('/my-streams');
    } catch (err) {
      setError(err.message || 'Failed to set password');
    } finally {
      setLoading(false);
    }
  };

  if (needsNewPassword) {
    return (
      <div className="nc-auth-page">
        <div className="nc-auth-card">
          <div className="nc-auth-eyebrow">NC LIVE</div>
          <h1 className="nc-auth-title">Set Password</h1>
          <p className="nc-auth-sub">Choose a new password to continue</p>
          {error && <div className="nc-auth-error">{error}</div>}
          <form onSubmit={handleNewPassword} className="nc-auth-form">
            <div className="nc-auth-field">
              <label>New Password</label>
              <input type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} required autoFocus />
            </div>
            <div className="nc-auth-field">
              <label>Confirm Password</label>
              <input type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required />
            </div>
            <button type="submit" className="nc-auth-btn" disabled={loading}>
              {loading ? 'Saving...' : 'Set Password'}
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="nc-auth-page">
      <div className="nc-auth-card">
        <div className="nc-auth-eyebrow">NC LIVE</div>
        <h1 className="nc-auth-title">Sign In</h1>
        <p className="nc-auth-sub">Access your streamer dashboard</p>
        {error && <div className="nc-auth-error">{error}</div>}
        <form onSubmit={handleSignIn} className="nc-auth-form">
          <div className="nc-auth-field">
            <label>Email</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} required autoFocus />
          </div>
          <div className="nc-auth-field">
            <label>Password</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} required />
          </div>
          <button type="submit" className="nc-auth-btn" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
